import { LocalStorageEventName } from '@/script/localStorage';
import { getLanguage } from '@/i18n';


// 存儲移動端塞入的版本、機型信息
const STORAGE_COMMON_PARAMS = 'STORAGE_COMMON_PARAMS'
const STORAGE_PLATFORM = 'STORAGE_PLATFORM'

// 存储app的下载渠道（不同渠道支付方式不同）
const STORAGE_CHANNEL = 'STORAGE_CHANNEL'

// 獲取或存儲版本號
const STORAGE_VERSION = 'STORAGE_VERSION'
// ios遭下架，另外申请应用，有两个应用包，得特殊处理
const STORAGE_VERSION_TAG = 'STORAGE_VERSION_TAG' 
window.getCommparams = function (commparams) {
  const commonParams = JSON.parse(commparams);
  console.log('getCommparams',commonParams);
  window.localStorage.setItem(LocalStorageEventName.region, commonParams.region) //地区
  window.localStorage.setItem(LocalStorageEventName.deviceLanguage, commonParams.deviceLanguage) //语音
  if (
    ['1', '2', '3', '5'].includes(String(commonParams.deviceLanguage))
  ) {
    getLanguage(commonParams.deviceLanguage, { source: 'app' })
  }
  window.localStorage.setItem(STORAGE_PLATFORM, commonParams.platform)
  window.localStorage.setItem(STORAGE_CHANNEL, commonParams.channel)// 存储app下载渠道
  window.localStorage.setItem(STORAGE_VERSION_TAG, commonParams.appFlag)// 存储ios包标识 nicee2是新提的ios包
  window.commParams = encodeURI(commparams)
  window.localStorage.setItem(STORAGE_COMMON_PARAMS, window.commParams)
  if (window.localStorage.getItem(STORAGE_VERSION) !== commonParams.version) {
    console.log('getCommparams2',commonParams);
    window.localStorage.setItem(STORAGE_VERSION, commonParams.version)
    window.location.reload()
  }
}
